import type { UserActivity } from "../activity";

function minutesLabel(total: number): string {
  if (total <= 0) return "0 dk";
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h === 0) return `${m} dk`;
  return `${h} sa ${m} dk`;
}

function StatCard({
  icon,
  tone,
  value,
  label,
  sub,
}: {
  icon: string;
  tone: "primary" | "accent" | "secondary";
  value: string;
  label: string;
  sub?: string;
}) {
  const tones: Record<string, string> = {
    primary: "bg-primary-100 text-primary-700",
    accent: "bg-accent-100 text-accent-800",
    secondary: "bg-secondary-100 text-secondary-900",
  };
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="flex items-center gap-2.5">
        <span className={`w-9 h-9 flex items-center justify-center rounded-md shrink-0 ${tones[tone]}`}>
          <i className={`${icon} text-base`} aria-hidden="true"></i>
        </span>
        <p className="text-xs text-foreground-500">{label}</p>
      </div>
      <p className="mt-2.5 font-heading text-xl font-bold text-foreground-950">{value}</p>
      {sub && <p className="mt-0.5 text-xs text-foreground-500">{sub}</p>}
    </div>
  );
}

export default function ActivityOverview({ activity }: { activity: UserActivity }) {
  const totalMinutes = activity.studySessions.reduce((s, x) => s + x.minutes, 0);
  const examCount = activity.examAttempts.length;
  const avgNet =
    examCount > 0
      ? activity.examAttempts.reduce((s, x) => s + x.net, 0) / examCount
      : 0;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      <StatCard
        icon="ri-time-line"
        tone="primary"
        value={minutesLabel(totalMinutes)}
        label="Toplam Çalışma"
        sub={`${activity.studySessions.length} oturum`}
      />
      <StatCard
        icon="ri-file-list-3-line"
        tone="accent"
        value={String(examCount)}
        label="Deneme Sınavı"
        sub={examCount > 0 ? `Ort. net ${avgNet.toFixed(2)}` : undefined}
      />
      <StatCard
        icon="ri-task-line"
        tone="secondary"
        value={String(activity.homework.length)}
        label="Ödev"
      />
      <StatCard
        icon="ri-alert-line"
        tone="accent"
        value={String(activity.weakTopics.length)}
        label="Zayıf Konu"
      />
      <StatCard
        icon="ri-sticky-note-line"
        tone="primary"
        value={String(activity.notes.length + activity.favorites.length)}
        label="Not & Favori"
        sub={`${activity.notes.length} not · ${activity.favorites.length} favori`}
      />
      <StatCard
        icon="ri-award-line"
        tone="secondary"
        value={String(activity.certificates.length)}
        label="Sertifika"
      />
    </div>
  );
}